import React from 'react';
import { Image, Text } from '@asigna/kit';

import plusIcon from './util/images/plus.svg';

export type AddContactButtonProps = {
  onClick: () => void;
};

export const AddContactButton: React.FC<AddContactButtonProps> = React.memo((props) => {
  const { onClick } = props;

  return (
    <button
      onClick={onClick}
      className="flex flex-col justify-center items-center gap-8 p-16 sm:p-24 rounded-[12px] border-primary border-[1px] border-dashed bg-primary-5 min-h-[120px]"
    >
      <div className="flex items-center justify-center rounded-[50%] w-32 h-32 bg-[linear-gradient(90deg,_#584BEA_0%,_#905CFF_100%)]">
        <Image src={plusIcon} size={14} />
      </div>
      <Text message="Add new contact" size="m15" />
    </button>
  );
});
